<div class="spinner-content" [@animate]="{ value: '*', params: { y: '20px', opacity: '0', delay: '100ms', duration: '400ms' } }" [@.disabled]="!animate">
  <mat-spinner mode="indeterminate" *ngIf="isLoading"></mat-spinner>

  <div class="spinner-content__main" [class.spinner-content__main--loading]="isLoading" [class.spinner-content__main--dark]="isDark">
    <ng-content></ng-content>
  </div>
</div>
